module.exports = __webpack_public_path__ + "static/media/Pic-01.1c1f8f2f.jpg";